import { render, staticRenderFns } from "./OnepersonOneFile.vue?vue&type=template&id=b8804986"
import script from "./OnepersonOneFile.vue?vue&type=script&lang=js"
export * from "./OnepersonOneFile.vue?vue&type=script&lang=js"
import style0 from "./OnepersonOneFile.vue?vue&type=style&index=0&id=b8804986&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports